import { useId, useState, type ReactNode } from 'react'

import { cn } from '../utilitarios/cn'

export interface PropriedadesDica {
  texto: ReactNode
  children?: ReactNode
  className?: string
}

/**
 * Tooltip acionável por teclado — é o `?` de ajuda ao lado de "Situação do Lead"
 * na TELA-05, onde a explicação da máquina de estados precisa estar a um passo.
 *
 * Abre no hover **e** no foco: dica que só existe no hover não existe para quem
 * navega por teclado nem no toque.
 */
export function Dica({ texto, children, className }: PropriedadesDica) {
  const [visivel, setVisivel] = useState(false)
  const id = useId()

  return (
    <span className={cn('relative inline-flex', className)}>
      <button
        type="button"
        aria-describedby={visivel ? id : undefined}
        aria-label="Ajuda"
        onMouseEnter={() => setVisivel(true)}
        onMouseLeave={() => setVisivel(false)}
        onFocus={() => setVisivel(true)}
        onBlur={() => setVisivel(false)}
        onClick={() => setVisivel((valor) => !valor)}
        className="inline-flex h-4 w-4 items-center justify-center rounded-full bg-superficie-3 text-[0.625rem] font-bold text-conteudo-suave hover:bg-borda-forte hover:text-conteudo focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-marca-500/40"
      >
        {children ?? '?'}
      </button>
      {visivel && (
        <span
          id={id}
          role="tooltip"
          className="absolute bottom-full left-1/2 z-50 mb-2 w-64 -translate-x-1/2 rounded-md bg-superficie-inversa px-3 py-2 text-xs font-normal normal-case leading-relaxed tracking-normal text-white shadow-lg"
        >
          {texto}
        </span>
      )}
    </span>
  )
}
